'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import curry from './curry';
import _enforceFunction from './internal/_enforceFunction';
import _enforceInterval from './internal/_enforceInterval';

function debounce(interval, operation) {
  _enforceInterval(interval);

  _enforceFunction(operation);

  var lastArgs;
  var lastResult;
  var timer = null;

  function cancel() {
    clearTimeout(timer);
    timer = null;
  }

  function runner() {
    cancel();
    lastResult = operation.apply(void 0, _toConsumableArray(lastArgs));
  }

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;
    cancel();
    timer = setTimeout(runner, interval);
    return lastResult;
  }

  debounced.cancel = cancel;
  return debounced;
}
/**
 * `operation` is called `interval` milliseconds after the most recent call.
 *
 * @param  {number} interval of milliseconds
 * @param  {Function} operation
 * @return {any} the most recent result of `operation`
 */


export default curry(debounce);